import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { selectAuthGuardState } from '../../features/auth/selectors/auth.selectors';
import { TokenManager } from '../../utils/storage/tokenmanager.storage';
import { RedirectStorage } from '../../utils/storage/redirectStorage';
import LoadingSpinner from '../ui/LoadingSpinner';

interface RequireAuthProps {
  children: JSX.Element;
}

const RequireAuth: React.FC<RequireAuthProps> = React.memo(({ children }) => {
  const { user, isLoading } = useAppSelector(selectAuthGuardState);
  const location = useLocation();

  // If still loading auth state, show spinner
  if (isLoading && !user && TokenManager.isAuthenticated()) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <LoadingSpinner size="lg" color="orange" />
      </div>
    );
  }

  const isAuthenticated = !!user || TokenManager.isAuthenticated();

  if (!isAuthenticated && !isLoading) {
    // Store the current location for post-login redirect
    RedirectStorage.setRedirectUrl(location.pathname + location.search);
    const loginPath = location.pathname.startsWith('/admin') ? '/admin/login' : '/login';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
});

export default RequireAuth;
